import _get from 'lodash/get';
import { connectModal } from 'redux-modal';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FeedbackModal from 'js/components/organisms/Modals/FeedbackModal';
import { hide } from 'js/store/actions/modal';
import { postFeedback } from 'js/store/actions/feedbackMenu';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';
export default compose(connect(function (state) {
  return {
    menuLoading: state.feedbackMenu.loading,
    menuSubmitting: state.feedbackMenu.submitting,
    menuLoadError: !state.feedbackMenu.loading && !state.feedbackMenu.metadata,
    menuLoadErrorMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_ERROR_MESSAGE'),
    features: _get(state.feedbackMenu, 'metadata.features'),
    featuresTitle: _get(state.feedbackMenu, 'metadata.feedback_title'),
    contactCheckboxText: _get(state.feedbackMenu, 'metadata.contact_checkbox'),
    submitButtonText: _get(state.feedbackMenu, 'metadata.button_feedback'),
    provideFeedbackTitle: _get(state.feedbackMenu, 'metadata.general_feedback_title'),
    provideFeedbackSubtitle: _get(state.feedbackMenu, 'metadata.general_feedback_subtitle'),
    feedbackSubmitFailureMessage: mapTextVariableNameToStaticLocalizedText('FEEDBACK_MENU_SUBMIT_ERROR_MESSAGE'),
    isMobileWidth: state.device.isMobileWidth
  };
}, function (dispatch) {
  return {
    submitFeedback: function submitFeedback(postFormData) {
      return dispatch(postFeedback(postFormData));
    },
    modalClose: function modalClose() {
      return dispatch(hide('FeedbackModal'));
    }
  };
}), connectModal({
  name: 'FeedbackModal',
  destroyOnHide: false
}))(FeedbackModal);